module.exports = __webpack_public_path__ + "static/shaka.34d2e1f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shaka.png
// module id = 129
// module chunks = 105603797122985 114276838955818 126609682503911 252234152318474